<template lang="pug">
	
	div.control.lang-switch
		a.lang.fr(v-bind:class="{active: language == 'fr'}" v-on:click="change('fr')") Fr
		.separator
		a.lang.en(v-bind:class="{active: language == 'en'}" v-on:click="change('en')") En

</template>


<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'

	import $ from 'jquery'
	import { TweenMax } from 'gsap'

	import Scroller from '../utils/scroller.js'

	
  @Component({
		name: 'LangSwitch',
		props: ["src"],
		components: { }
	})

	class LangSwitch extends Vue {

		mounted () {

			this.$events.on('app.loaded', this.init)

		}

		init () {

			this.scroller = new Scroller();

		}

		_resize () {

		}

		change(lang = 'fr') {

			this.language = lang;
			
			window.location.reload();

		}

	}

	export default LangSwitch

</script>

<style lang="stylus" scoped>

	@import '../theme/variables'
	@import '../theme/utils'

	.control.lang-switch
		position relative
		display flex
		align-items center
		justify-content center
		color $COLOR_WHITE

		.separator
			height 14px
			width 1px
			background #fff
			display block
			margin 0 10px 0 8px

		.lang
			cursor pointer
			opacity .7
		
			&.active
			&:hover
				opacity 1


</style>


// WEBPACK FOOTER //
// lang-switch.vue?019562bd